import * as emailAttributeUtil from 'EmailData/utils/emailAttributeUtil';
import * as emailStateUtil from 'EmailData/utils/emailStateUtil';
import { getEmailPreviewUrl } from 'EmailData/utils/getEmailPreviewUrl';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { getIsCrmObject } from 'email-management-lib/Shared/utils/crmObject';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
const CATEGORY_ID = 2;
const DEFAULT_BU_ID = 0;
const defaults = {
  archived: false,
  author: '',
  businessUnitId: DEFAULT_BU_ID,
  categoryId: CATEGORY_ID,
  created: 0,
  crmObjectId: 0,
  emailTemplateMode: 'DRAG_AND_DROP',
  emailType: 'BATCH_EMAIL',
  folderId: undefined,
  id: 0,
  language: 'en',
  name: '',
  previewKey: '',
  processingStatus: '',
  publishDate: '',
  publishedById: undefined,
  rssToEmailTiming: undefined,
  state: 'DRAFT',
  securityState: 'NONE',
  subcategory: 'batch',
  subscription: null,
  transactional: false,
  teamPerms: [],
  updated: 0,
  userPerms: [],
  messageTags: null
};
const CrmObjectProperties = {
  [PROPERTIES.ARCHIVED]: 'archived',
  [PROPERTIES.AUTHOR]: 'author',
  [PROPERTIES.BUSINESS_UNIT_IDS]: 'businessUnitId',
  [PROPERTIES.CREATED_AT]: 'created',
  [PROPERTIES.EMAIL_TEMPLATE_MODE]: 'emailTemplateMode',
  [PROPERTIES.EMAIL_TYPE]: 'emailType',
  [PROPERTIES.FOLDER_ID]: 'folderId',
  [PROPERTIES.LANGUAGE]: 'language',
  [PROPERTIES.MARKETING_EMAIL_ID]: 'id',
  [PROPERTIES.NAME]: 'name',
  [PROPERTIES.PREVIEW_KEY]: 'previewKey',
  [PROPERTIES.PROCESSING_STATUS]: 'processingStatus',
  [PROPERTIES.PUBLISH_AUTHOR]: 'publishedById',
  [PROPERTIES.PUBLISHED_DATE]: 'publishDate',
  [PROPERTIES.RSS_TO_EMAIL_TIMING]: 'rssToEmailTiming',
  [PROPERTIES.SECURITY_STATE]: 'securityState',
  [PROPERTIES.STATE]: 'state',
  [PROPERTIES.SUBCATEGORY]: 'subcategory',
  [PROPERTIES.TEAM_IDS]: 'teamPerms',
  [PROPERTIES.USER_IDS]: 'userPerms',
  [PROPERTIES.SUBSCRIPTION]: 'subscription',
  [PROPERTIES.ERROR_TAGS]: 'messageTags',
  [PROPERTIES.LAST_UPDATED]: 'updated',
  [PROPERTIES.OBJECT_ID]: 'crmObjectId'
};
function getValueFromCrmObject(crmObject, propertyName) {
  return getPropertyValue(crmObject, propertyName, defaults[CrmObjectProperties[propertyName]]);
}
export function convertCrmToEmail(crmObject) {
  var _getValueFromCrmObjec, _getValueFromCrmObjec2, _getValueFromCrmObjec3;
  return {
    archived: getValueFromCrmObject(crmObject, PROPERTIES.ARCHIVED) === 'true',
    author: getValueFromCrmObject(crmObject, PROPERTIES.AUTHOR),
    businessUnitId: parseInt(getValueFromCrmObject(crmObject, PROPERTIES.BUSINESS_UNIT_IDS), 10),
    categoryId: CATEGORY_ID,
    crmObjectId: Number(getValueFromCrmObject(crmObject, PROPERTIES.OBJECT_ID)),
    created: Number(getValueFromCrmObject(crmObject, PROPERTIES.CREATED_AT)),
    emailTemplateMode: getValueFromCrmObject(crmObject, PROPERTIES.EMAIL_TEMPLATE_MODE),
    emailType: getValueFromCrmObject(crmObject, PROPERTIES.EMAIL_TYPE),
    folderId: parseInt(getValueFromCrmObject(crmObject, PROPERTIES.FOLDER_ID), 10),
    id: parseInt(getValueFromCrmObject(crmObject, PROPERTIES.MARKETING_EMAIL_ID), 10),
    language: getValueFromCrmObject(crmObject, PROPERTIES.LANGUAGE),
    messageTags: (_getValueFromCrmObjec = getValueFromCrmObject(crmObject, PROPERTIES.ERROR_TAGS)) === null || _getValueFromCrmObjec === void 0 ? void 0 : _getValueFromCrmObjec.split(';').map(tag => tag.toUpperCase()),
    name: getValueFromCrmObject(crmObject, PROPERTIES.NAME),
    publishedById: parseInt(getValueFromCrmObject(crmObject, PROPERTIES.PUBLISH_AUTHOR), 10),
    publishDate: getValueFromCrmObject(crmObject, PROPERTIES.PUBLISHED_DATE),
    previewKey: getValueFromCrmObject(crmObject, PROPERTIES.PREVIEW_KEY),
    processingStatus: (_getValueFromCrmObjec2 = getValueFromCrmObject(crmObject, PROPERTIES.PROCESSING_STATUS)) === null || _getValueFromCrmObjec2 === void 0 ? void 0 : _getValueFromCrmObjec2.toUpperCase(),
    rssToEmailTiming: JSON.parse((_getValueFromCrmObjec3 = getValueFromCrmObject(crmObject, PROPERTIES.RSS_TO_EMAIL_TIMING)) !== null && _getValueFromCrmObjec3 !== void 0 ? _getValueFromCrmObjec3 : '{}'),
    securityState: getValueFromCrmObject(crmObject, PROPERTIES.SECURITY_STATE),
    state: getValueFromCrmObject(crmObject, PROPERTIES.STATE),
    subcategory: getValueFromCrmObject(crmObject, PROPERTIES.SUBCATEGORY),
    subscription: getValueFromCrmObject(crmObject, PROPERTIES.SUBSCRIPTION),
    teamPerms: typeof getValueFromCrmObject(crmObject, PROPERTIES.TEAM_IDS) === 'string' ? getValueFromCrmObject(crmObject, PROPERTIES.TEAM_IDS).split(';').map(Number) : getValueFromCrmObject(crmObject, PROPERTIES.TEAM_IDS),
    transactional: getValueFromCrmObject(crmObject, PROPERTIES.SUBSCRIPTION) === '-1',
    updated: Number(getValueFromCrmObject(crmObject, PROPERTIES.LAST_UPDATED)),
    userPerms: typeof getValueFromCrmObject(crmObject, PROPERTIES.USER_IDS) === 'string' ? getValueFromCrmObject(crmObject, PROPERTIES.USER_IDS).split(';').map(Number) : getValueFromCrmObject(crmObject, PROPERTIES.USER_IDS)
  };
}
class EmailModel {
  constructor(_fields = defaults) {
    const fields = Object.assign({}, defaults, _fields);
    this.archived = fields.archived;
    this.author = fields.author;
    this.businessUnitId = fields.businessUnitId;
    this.categoryId = fields.categoryId;
    this.crmObjectId = fields.crmObjectId;
    this.created = fields.created;
    this.emailTemplateMode = fields.emailTemplateMode;
    this.emailType = fields.emailType;
    this.folderId = fields.folderId;
    this.id = fields.id;
    this.language = fields.language;
    this.messageTags = fields.messageTags;
    this.name = fields.name;
    this.publishDate = fields.publishDate;
    this.previewKey = fields.previewKey;
    this.processingStatus = fields.processingStatus;
    this.rssToEmailTiming = fields.rssToEmailTiming;
    this.securityState = fields.securityState;
    this.state = fields.state;
    this.subcategory = fields.subcategory;
    this.subscription = fields.subscription;
    this.teamPerms = fields.teamPerms;
    this.transactional = fields.transactional;
    this.updated = fields.updated;
    this.userPerms = fields.userPerms;
  }
  static from(json) {
    const isCrmObject = getIsCrmObject(json);
    return new EmailModel(isCrmObject ? convertCrmToEmail(json) : json);
  }
  isPublished() {
    return emailStateUtil.getIsPublished(this);
  }
  isABAutomatedPublishedEmail() {
    return this.isABAutomatedEmail() && this.isPublishedAutomated();
  }
  isScheduled() {
    return emailStateUtil.getIsScheduled(this);
  }
  isDraft() {
    return emailStateUtil.getIsDraft(this);
  }
  isErrored() {
    return emailStateUtil.getIsError(this);
  }
  isProcessing() {
    return emailStateUtil.getIsProcessing(this);
  }
  isPreProcessing() {
    return emailStateUtil.getIsPreProcessing(this);
  }
  isInitializing() {
    return emailStateUtil.getIsInitializing(this);
  }
  isArchived() {
    return this.archived;
  }
  isAutomatedForForm() {
    return emailStateUtil.getIsAutomatedForForm(this);
  }
  isBatch() {
    return emailStateUtil.getIsBatchEmail(this);
  }
  isAutomated() {
    return emailStateUtil.getIsAutomated(this);
  }
  isAutomatedLike() {
    return emailStateUtil.getIsAutomatedLike(this);
  }
  isLocalTime() {
    return emailStateUtil.getIsLocalTime(this);
  }
  isPublishedAutomated() {
    return emailStateUtil.getIsPublishedAutomated(this);
  }
  isFollowup() {
    return emailStateUtil.getIsFollowupEmail(this);
  }
  isSingleSendApi() {
    return emailStateUtil.getIsSingleSendApi(this);
  }
  isBlogEmail() {
    return emailStateUtil.getIsBlogEmail(this);
  }
  isBlogChildEmail() {
    return emailStateUtil.getIsBlogEmailChild(this);
  }
  isABEmail() {
    return emailStateUtil.getIsAbEmail(this);
  }
  isABAutomatedEmail() {
    return emailStateUtil.getIsAbAutomated(this);
  }
  isABLike() {
    return emailStateUtil.getIsAbLike(this);
  }
  isRssEmail() {
    return emailStateUtil.getIsRssEmail(this);
  }
  isRssChildEmail() {
    return emailStateUtil.getIsRssEmailChild(this);
  }
  isOptinEmail() {
    return emailStateUtil.getIsOptinEmail(this);
  }
  isLeadFlowEmail() {
    return emailStateUtil.getIsLeadflowEmail(this);
  }
  isTicketEmail() {
    return emailStateUtil.getIsTicketEmail(this);
  }
  isFeedbackEmail() {
    return emailStateUtil.getIsFeedbackLikeEmail(this);
  }
  isSmtpEmail() {
    return emailStateUtil.getIsSmtpToken(this);
  }
  isAbandonedCartEmail() {
    return emailStateUtil.getIsAutomatedForDeal(this);
  }
  isTransactionalEmail() {
    return this.transactional;
  }
  isAvailableToWorkflows() {
    return emailStateUtil.getIsAvailableToWorkflows(this);
  }
  hasLoaded() {
    return this.emailType !== defaults.emailType;
  }
  wasForciblyCancelled() {
    return emailStateUtil.getIsForciblyCanceled(this);
  }
  wasCanceled() {
    return emailStateUtil.getIsCanceled(this);
  }
  wasCanceledForAbuse() {
    return emailStateUtil.getIsCanceledForAbuse(this);
  }
  getPreviewUrl(convertToDragDrop = false) {
    const isDraftEmail = !(this.isPublished() || this.isScheduled());
    return getEmailPreviewUrl(this.id || 0, this.previewKey || '', isDraftEmail, convertToDragDrop);
  }
  canCancelOrUnpublish() {
    return emailAttributeUtil.getCanCancelOrUnpublish(this);
  }
}
export default EmailModel;